import * as tslib_1 from "tslib";
import { OnDestroy, } from '@angular/core';
import { UiModalComponent } from '@components';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject, } from 'rxjs';
import { BulkAddItemsModalService } from './bulk-add-items.service';
import { BulkCommitType, } from './bulk-add-items.types';
var BulkAddItemsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BulkAddItemsModalComponent, _super);
    function BulkAddItemsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.BulkCommitType = BulkCommitType;
        _this.commitTypeOption = BulkCommitType.ProcessAllIndependently;
        _this.loading$ = new BehaviorSubject(false);
        _this.responseFailedItems = [];
        _this._destroyed$ = new Subject();
        _this._bulkAddService = _this._injector.get(BulkAddItemsModalService);
        _this._translateService = _this._injector.get(TranslateService);
        return _this;
    }
    Object.defineProperty(BulkAddItemsModalComponent.prototype, "fileName", {
        get: function () {
            return this.file ? this.file.name : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BulkAddItemsModalComponent.prototype, "disableSubmit", {
        get: function () {
            return !this.file ||
                !this.parsed ||
                this.parsed.errors.length > 0 ||
                this.parsed.data.length === 0 ||
                this.responseFailedItems.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BulkAddItemsModalComponent.prototype, "helpInfo", {
        get: function () {
            return {
                supportedDateFormats: this._bulkAddService.supportedDateFormats,
                priorityValues: ['"Low" / 1', '"Normal" / 2', '"High" / 3'],
            };
        },
        enumerable: true,
        configurable: true
    });
    BulkAddItemsModalComponent.prototype.getScrollHeight = function (itemsCount) {
        return Math.min(6, itemsCount) * 41;
    };
    BulkAddItemsModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    BulkAddItemsModalComponent.prototype.onClear = function () {
        this.file = undefined;
        this.parsed = undefined;
        this.responseFailedItems = [];
    };
    BulkAddItemsModalComponent.prototype.onFileChange = function (_a) {
        var _this = this;
        var file = _a[0];
        this.onClear();
        this.loading$.next(true);
        this.file = file;
        this._bulkAddService.parseFile(file)
            .subscribe(function (parsedResponse) {
            _this.parsed = parsedResponse;
            _this.loading$.next(false);
        }, function (err) {
            _this._snack.error(err);
            _this.onClear();
            _this.loading$.next(false);
        });
    };
    BulkAddItemsModalComponent.prototype.onSubmit = function () {
        var _this = this;
        this.loading$.next(true);
        this._bulkAddService.bulkAddQueueItems(this.parsed.data, this.context.data.name, this.commitTypeOption).subscribe(function (response) {
            if (!response.success) {
                _this.responseFailedItems = response.failedItems || [];
                _this._snack.error(response.message);
                _this.loading$.next(false);
                return;
            }
            _this._snack.success(_this._translateService.instant('queue_bulk_add_items_success', {
                count: _this.parsed.data.length,
            }));
            _this._dialogRef.close({ type: 1 /* Add */ });
        }, function () {
            _this.loading$.next(false);
        });
    };
    BulkAddItemsModalComponent.prototype.onDownloadUnprocessedRows = function () {
        var _this = this;
        if (!this.responseFailedItems.length) {
            return;
        }
        var unprocessedRows = this.responseFailedItems
            .map(function (failed) { return _this.parsed.data[failed.row - 1]; });
        this._bulkAddService.downloadFile(this.file.name, this._translateService.instant('queue_bulk_output_csv_filename_suffix'), unprocessedRows);
    };
    return BulkAddItemsModalComponent;
}(UiModalComponent));
export { BulkAddItemsModalComponent };
